import React, { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";
import { observer } from "mobx-react-lite";

import useThemeService from "../../services/theme-service/ThemeService";
import TranslationService from "../../services/translation/TranslationService";
import Svg from "../svg/Svg";
import { DASHBOARD, MainMenuItemCategory } from "../../services/main-menu/MainMenuService";

interface MainMenuItemProps {
  svg: FunctionComponent;
  item: MainMenuItemCategory;
  wideMenu: boolean;
}

export default observer(function MainMenuItem(props: MainMenuItemProps) {
  const { svg, wideMenu, item } = { ...props };
  const isHomepage = item.name === DASHBOARD;
  const path = !isHomepage ? `/${item.path || item.name}` : "/";

  const { themeClass } = useThemeService();
  const { translate } = TranslationService();

  return (
    <NavLink
      exact={isHomepage}
      key={item.name}
      to={path}
      className={themeClass(["main-menu-items"])}
      activeClassName="selected"
      isActive={(match, location) => {
        if (isHomepage && location.pathname === "/") return true;
        if (!isHomepage && location.pathname.startsWith(path)) return true;
        if (item.aliases) return item.aliases.some((alias) => location.pathname.includes(alias));
        return false;
      }}
    >
      <Svg svg={svg} alt={`icon-${item.name}`} />
      {wideMenu && <span className="main-menu-text">{translate(`general.${item.name}`)}</span>}
    </NavLink>
  );
});
